import React, { JSX } from 'react';

import { sanitize } from '@ibe/services';
import { BookedItemComponentProps } from '../../../Models/ItemRegistry';
import { Price } from '../../Components/UI/Price/Price';
import Dates from '../Dates';

const Cart = (props: BookedItemComponentProps): JSX.Element => {
  const { item } = props;

  const price = item.price || null;
  const description = item.description || null;

  return (
    <div className="item-cart d-flex justify-content-between align-items-center">
      <div>
        <h6 className="my-0">{item.name}</h6>
        <Dates item={item} />
        {description && <div dangerouslySetInnerHTML={{ __html: sanitize(description) }} />}
      </div>
      <span className="text-muted ml-1">{price && <Price price={price} />}</span>
    </div>
  );
};

export default Cart;
